var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-highlighted"},_vm._l((_vm.textWords),function(word,i){return _c('span',{key:i,class:{ highlight: i === 1 }},[_vm._v(_vm._s(word))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }